import React from 'react';
import styled from 'styled-components';
import Footer from './Footer';
import Navbar from './Navbar';
import DesktopMenu from './DesktopMenu';
import gif from '../images/spin.gif'




const Terms = () => {



    return (
        <>
<Navbar/>
<DeskWrap>
<DesktopMenu/>
<Gif src= {gif}/>

<Wrapper>
  <H1>Spectral Center Hypnosis — Terms & Conditions</H1>
  <Body>

    <LegalNotice>
      <h3>Legal Notice</h3>
      <p>Spectral Center ASBL</p>
      <p>Enterprise number: BE 1038.141.906</p>
      <p>Registered office: Rue de Fierlant 27, 1190 Forest, Belgium</p>
      <p>RPM Bruxelles</p>
      <p>Email: <WebLink href="mailto:spectralcenterhypnosis@gmail.com">spectralcenterhypnosis@gmail.com</WebLink></p>
      <p>Phone: +32 467 882281</p>
    </LegalNotice>

    <p><strong>Effective Date:</strong> 01.04.2024</p>
    <p>
      Welcome to Spectral Center Hypnosis. By accessing or using this website (https://spectral.center),
      our digital products, services, or attending our sessions and events, you agree to the following
      terms and conditions. Please read them carefully.
    </p>

    <h3>1. General Disclaimer</h3>
    <p>
      The content provided on this website and through our hypnosis services, recordings, and workshops
      is intended for informational and self-development purposes only. It does not constitute medical,
      psychological, or psychiatric advice.
    </p>

    <h3>2. No Medical or Psychological Claims</h3>
    <p>
      Hypnotherapy services provided by Spectral Center are not intended to diagnose, treat, or cure any
      condition or disease.
    </p>

    <h3>3. Individual Results May Vary</h3>
    <p>
      While many users experience great personal insight and growth, outcomes are subjective and not guaranteed.
    </p>

    <h3>4. Use at Your Own Risk</h3>
    <p>
      You agree to use all hypnosis recordings and materials at your own discretion. We are not responsible
      for any resulting outcomes.
    </p>

    <h3>5. Safety Notice for Audio Recordings</h3>
    <p>
      Do not listen to recordings while driving or operating machinery. Hypnosis requires a quiet and
      safe environment.
    </p>

    <h3>6. Age Restriction</h3>
    <p>
      All services are intended for individuals aged 18 and over. Under 18s must have guardian consent.
    </p>

    <h3>7. Intellectual Property</h3>
    <p>
      All content is the intellectual property of Spectral Center Hypnosis and Julia E. Dyck and may not
      be reproduced or distributed without permission.
    </p>

    <h3>8. Refund Policy</h3>
    <p>
      All digital products are non-refundable once accessed or downloaded. Event cancellation terms vary
      per event.
    </p>

    <h3>9. Confidentiality</h3>
    <p>
      All personal information from 1:1 sessions is held in strict confidence, except when required by law.
    </p>

    <h3>10. Limitation of Liability</h3>
    <p>
      Spectral Center Hypnosis disclaims all liability for any damages arising from the use of its
      services or products.
    </p>

    <h3>11. Modifications to Terms</h3>
    <p>
      We reserve the right to modify these terms at any time without notice. Continued use signifies
      acceptance of any changes.
    </p>

    <p><strong>Contact:</strong></p>
    <p>Email: <WebLink href="mailto:spectralcenterhypnosis@gmail.com">spectralcenterhypnosis@gmail.com</WebLink></p>
    <p>Phone: +32 467 882281</p>
  </Body>
</Wrapper>

    </DeskWrap>
    <Footer/>
    </>
    );
    
    }

    const WebLink = styled.a`
color: var(--ink);
text-decoration: none;`

    const Gif = styled.img`
    max-width: 100px;
    position: absolute;
    margin-left: 200px;
    z-index: 1000;
    top: 5px;
    right: 5px;

    @media (min-width: 1000px) {
        max-width: 150px;
    position: absolute;
    z-index: 1000;
    top: 5px;
    right: 100px;
    }
    `
const DeskWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;

    @media (min-width: 1000px) {
flex-direction: row;

}
`


const Wrapper=styled.div`
    display: flex;
    padding: 2%;
    flex-direction: column;
    justify-content: space-between;
    height: 90%;
    width: 90%;
    margin: 2%;

    @media (min-width: 500px) { }

    @media (min-width: 1000px) {

        justify-content: flex-start;
        height: 100%;
        padding: 0%;
        margin-right: 10%;
        width: 100%;


     }

    `


const Body = styled.div`
   font-family: var(--font-body);
   margin-top: 3%;

   
   @media (min-width: 1000px) {

margin-top: 0%;


}
`

const LegalNotice = styled.div`
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
    background: rgba(0,0,0,0.02);

    h3 {
        margin-top: 0;
    }

    p {
        margin: 0.25rem 0;
    }
`



const H1 = styled.h1`
font-size: 20px;
`

    export default Terms;
